import React from 'react';

import ExamForm from '../../Components/ExamForm';

export default function ExamCreator() {
  return (
    <div>
      <ExamForm />
    </div>
  );
}
